<template>
  <div id="genres-index-list">
    <b-collapse :id="collapseId"
                :visible="visible"
                class="genres-collapse"
    >
      <div class="genres">
        <div class="genres__inner">
          <Loading v-if="loading" color="black"/>
          <template v-else>
            <div class="genres-index-list fade-in-top-fast">
              <template v-for="(genre, index) in genres">
                <div :key="genre.parent.id" class="genres-index-list__button">
                  <button v-b-toggle="`${genre.parent.id}-${index}`"
                          type="button"
                          class="genre-collapse-btn"
                  >
                    <IconPlus/>
                  </button>
                  <button
                    type="button"
                    class="genre-collapse-btn-label"
                    :class="{active: setGenreButtonState(genre.parent.id)}"
                    :disabled="genreSelectionLimit"
                    @click="setParentTagSelection(genre)"
                  >
                    {{ genre.parent.name }}
                  </button>
                </div>
                <b-collapse :visible="isCollapseVisible" :id="`${genre.parent.id}-${index}`" :key="genre.parent.name">
                  <div class="sub-genres">
                    <button v-for="subgenre in genre.subGenres"
                            :key="subgenre.id"
                            type="button"
                            :class="{active: setGenreButtonState(subgenre.id)}"
                            class="sub-genres-btn"
                            :disabled="genreSelectionLimit"
                            @click="setChildTagSelection(subgenre)"
                    >
                      {{ subgenre.name }}
                    </button>
                  </div>
                </b-collapse>
              </template>
            </div>
          </template>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import Loading from "@/components/ui/Loading";
import {mapState} from "vuex";
import axios from "axios";
import IconPlus from "@/components/ui/IconPlus.vue";

export default {
  name: "GenresIndexList",
  components: {
    IconPlus,
    Loading
  },
  props: {
    collapseId: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      required: false,
      default: false
    },
    genres: {
      type: Array,
      required: true,
      default: () => []
    },
    collapseVisible: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    loading: false,
    selectedGenres: [],
  }),

  computed: {
    ...mapState({
      selectedGenresStore: state => state.selectedGenres,
    }),
    genreSelectionLimit() {
      return this.selectedGenres.length >= 3;
    },
    isCollapseVisible() {
      return this.collapseVisible;
    }
  },

  watch: {
    selectedGenres(value) {
      this.$store.commit('setGenres', value);
    },
    selectedGenresStore(value) {
      this.selectedGenres = value;
    }
  },

  methods: {

    setChildTagSelection(subGenre) {
      const currentGenreId = this.selectedGenres.find((genre) => genre.id === subGenre.id);
      if (currentGenreId === undefined) {
        const parentTagIsSelected = this.selectedGenres.find((genre) => genre.id === subGenre.tag.id);
        if (parentTagIsSelected !== undefined) { // remove parent tag if child is selected
          const parentTagIndex = this.selectedGenres.indexOf(parentTagIsSelected);
          this.selectedGenres.splice(parentTagIndex, 1);
        }
        this.selectedGenres.push(subGenre);
      } else {
        const selectedGenreIndex = this.selectedGenres.indexOf(subGenre);
        this.selectedGenres.splice(selectedGenreIndex, 1);
      }
    },

    setParentTagSelection(genre) {
      const currentParentGenreId = this.selectedGenres.find((tag) => tag.id === genre.parent.id);
      if (currentParentGenreId === undefined) {
        this.selectedGenres.push(genre.parent);
      } else {
        const selectedParentGenreIndex = this.selectedGenres.indexOf(genre.parent);
        this.selectedGenres.splice(selectedParentGenreIndex, 1);
      }
      const subIds = genre.subGenres.map((genre) => genre.id);
      const found = this.selectedGenres.filter((genre) => subIds.includes(genre.id));
      found.forEach((genre) => {
        const childIndex = this.selectedGenres.indexOf(genre);
        this.selectedGenres.splice(childIndex, 1);
      });
    },

    setGenreButtonState(id) {
      return this.selectedGenres.some((genre) => genre.id === id);
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/sass/abstracts/_variables.scss";

.genres-index-list {
  position: relative;
  padding: 0 4px;

  &__button {
    display: flex;
    align-items: center;
    color: $c_black;
    margin-bottom: 10px;
  }
}

.sub-genres {
  padding-bottom: 10px;
  max-width: 380px;
  display: flex;
  flex-wrap: wrap;
  margin-left: 50px;
}

.genre-collapse-btn {
  display: flex;
  background-color: $c_white;
  color: $c_black;
  @include font-12-md;
  position: relative;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  transition: all 0.2s ease;
  @include media-breakpoint-down(md) {
    padding: 0;
    width: 30px;
    height: 30px;
    //@include font-20-md;
    //line-height: 1.3;
  }

  svg {
    display: flex;
    fill: $c_black;
    width: 14px;
    height: 14px;
    @include media-breakpoint-up(md) {
      width: 10px;
      height: 10px;
    }
  }

  &:hover {
    @include media-breakpoint-up(md) {
      color: $c_white !important;
      background-color: $c_base !important;
      svg {
        fill: $c_white !important;
      }
    }
  }

  &:not(.collapsed) {
    background-color: $c_grey_border;
    transform: rotate(45deg);

    svg {
      fill: $c_white;
    }
  }
}

.genre-collapse-btn-label {
  @include font-14;
  display: flex;
  background-color: transparent;
  border-radius: 6px;
  border: 1px solid $c_medium_grey !important;
  padding: 10px 20px;
  color: $c_black;
  margin-left: 15px;

  @include media-breakpoint-down(md) {
    @include font-14-md;
  }

  &:hover, &.active:hover {
    @include media-breakpoint-up(lg) {
      background-color: $c_white;
      color: $c_black;
      border: 1px solid $c_white;
    }
  }

  &.active {
    background-color: $c_black;
    color: $c_white;
  }

  &:disabled {
    transition: filter .2s ease;
    filter: opacity(1);
    cursor: not-allowed;
    &:hover {
      color: unset;
      background-color: unset;
      border: 1px solid $c_medium_grey;
      filter: opacity(0.5);
      &.active {
        background-color: $c_black !important;
        color: $c_white !important;
      }
    }
    @include media-breakpoint-down(md){
      filter: opacity(0.5);
    }
  }
}

.sub-genres-btn {
  background-color: transparent;
  border-radius: 6px;
  border: 1px solid $c_medium_grey !important;
  color: $c_black;
  @include font-12;
  padding: 8px 16px;
  margin-right: 6px;
  margin-bottom: 6px;

  &.active {
    background-color: $c_black;
    color: $c_white;
  }

  &:hover {
    @include media-breakpoint-up(lg) {
      background-color: $c_white;
      color: $c_black;
      border: 1px solid $c_white !important;
    }
  }

  &:disabled {
    transition: filter .2s ease;
    filter: opacity(1);
    cursor: not-allowed;
    border: 1px solid $c_medium_grey;
    &:hover {
      color: unset;
      background-color: unset;
      border: 1px solid $c_medium_grey !important;
      filter: opacity(0.5);
      &.active {
        background-color: $c_black !important;
        color: $c_white !important;
      }
    }
    @include media-breakpoint-down(md){
      filter: opacity(0.5);
    }
  }
}

.genres-collapse {
  top: 0;
  position: fixed;
  width: 100%;
  z-index: 1;
}

.genres {
  height: calc(100vh - 200px);
  overflow-y: scroll;
  margin-top: 200px;
  background-color: $c_light_grey_fill;
  @include media-breakpoint-down(lg) {
    height: calc(100vh - 240px);
    margin-top: 240px;
  }

  &__inner {
    max-width: 1167px;
    margin: 0 auto;
    padding: 40px 28px;
    @include media-breakpoint-down(lg) {
      padding: 40px 20px 80px 20px;
    }
    @include media-breakpoint-down(md) {
      padding: 40px 24px 80px 24px;
    }
    @include media-breakpoint-up(xxxl) {
      max-width: 100%;
      padding: 40px 20px;
    }
  }
}

</style>
